import { Moment } from "moment";
import { ClasseAtivo, Mercado, TipoOperacao, Trade } from "./enum";

export default class Transacao implements ITransacao {
  public dataTransacao!: Moment;
  public classeAtivo!: ClasseAtivo;
  public daytradeSwingtrade!: Trade;
  public codigoAtivo!: string;
  public mercado!: Mercado;
  public valorVendido?: number;
  public resultado!: number;
  public irrf!: number;
  public posicao?: {
    quantidade: number;
    precoMedio: number;
    tipoOperacao: TipoOperacao;
  };
  public operacao?: {
    quantidade: number;
    precoUnitario: number;
    tipoOperacao: TipoOperacao;
    taxas: number;
  };

  constructor(param: ITransacao) {
    Object.assign(this, param);
  }
}

interface ITransacao {
  dataTransacao: Moment;
  classeAtivo: string;
  daytradeSwingtrade: Trade;
  codigoAtivo: string;
  mercado: Mercado;
  valorVendido?: number;
  resultado: number;
  irrf: number;
  posicao?: {
    quantidade: number;
    precoMedio: number;
    tipoOperacao: TipoOperacao;
  };
  operacao?: {
    quantidade: number;
    precoUnitario: number;
    tipoOperacao: TipoOperacao;
    taxas: number;
  };
}
